export default {
  ACCEPT_SIGN: 'Accept & Sign',
  ACKNOWLEDGEMENT: 'Acknowledgement',
  ADD_A_DOCUMENT_TO_GET_STARTED_WITH_E_SIGNATURES: 'Add a document to get started with e-signatures',
  ADD_A_DOCUMENT_TO_GET_STARTED: 'Add a document to get started',
  ADD_DOCUMENT: 'Add document',
  ADD_DOCUMENTS: 'Add documents',
  ADD_ENHANCED_ESIGNATURE: '{startOfSentence}dd Enhanced E-Signature',
  ADD_ONS: 'Add-ons',
  ADD_YOUR_SIGNATURE: 'Add your signature',
  ADDING_SIGNATURE_TO_DOCUMENT: 'Adding signature to document',
  ADDON: 'Addon',
  ALL_EMPLOYEES_COUNT: 'All Employees ({employeeCount})',
  ALL_EMPLOYEES: 'All Employees',
  BY: 'by',
  CAN_COMPLETE_SIGNATURE_REQUESTS: 'Employees will be able to complete existing signature requests.',
  CANCEL: 'Cancel',
  CANNOT_EXCEED_40MB: 'File uploads cannot exceed 40 MB.',
  CATEGORY: 'Category',
  CATEGORIES: 'Categories',
  CATEGORY_CANNOT_EXCEED_50_CHARACTERS: 'Category title cannot exceed 50 characters',
  CATEGORY_CANNOT_BE_BLANK: 'Category cannot be blank (must include at least one non-whitespace character).',
  CHOOSE_A_FILE: 'choose a file',
  CHOOSE_THE_SIGNATURE_OPTION: "Choose the signature option that's best for your document",
  COMPANY: 'Company',
  COMPANY_DOCUMENTS: 'Company documents',
  COMPANY_DOCUMENTS_VISIBILITY_TOOLTIP: 'Documents that you publish to employees are visible to all employees in the company.' +
  '\n\nEmployees can access the documents in their Employee Documents folder.' +
  '\n\nYou can only publish documents that don\'t require signatures.',
  CONFIGURE_NEW_DOCUMENTS: 'Configure new Enhanced E-Signature documents.',
  CONFIGURE_TEMPLATE: 'Configure template',
  CONFIGURING_TEMPLATE: 'Configuring template',
  CONTACT_CUSTOMER_SERVICE_FOR_ADD_ON: 'Contact your customer service representative for pricing and to enable or disable this add-on.',
  CONTINUE_STANDARD_AT_NO_COST: 'Continue to use standard E-Signature documents at no cost.',
  CONTINUE_ENHANCED_AT_NO_COST: 'Continue to use Enhanced E-Signature documents in onboarding at no cost.',
  CONVERTING_TO_PDF: 'converting the file to PDF',
  COST: 'Cost',
  CREATING_SIGNATURE_REQUEST: 'Creating signature request',
  CREATING_SIMPLE_SIGN_DOCUMENT: 'creating simple sign document',
  CUSTOMIZE_PLAN: 'Customize and enhance your plan with additional features.',
  DISABLE: 'Disable',
  DISABLE_AT_ANY_TIME: 'Disable Enhanced E-Signature at any time.',
  DISABLE_ENHANCED_ESIGNATURE: 'Disable Enhanced E-Signature',
  DISCARD_CHANGES: 'Discard changes?',
  DISPLAY_NAME: 'Display name',
  DOCUMENT: 'Document',
  DOCUMENT_CATEGORY: 'Document category',
  DOCUMENT_LOADING_PLEASE_WAIT: 'Document loading. Please wait...',
  DOC_FOR_YOU_TO_DOWNLOAD: 'Documents for you to download',
  DOWNLOAD: 'Download',
  DANGER: 'Danger',
  DELETE: 'Delete',
  DELETING: 'Deleting',
  DELETE_DOCUMENT_QUESTION: 'Delete this document?',
  DELETE_PENDING_EE_DOC_DETAIL: 'The signature request for this document will be cancelled and the employee will be notified by email.',
  DELETE_PENDING_ENHANCED_EE_DOC_DETAIL: 'The signature request for this document will be cancelled and the employee will be notified by email.' +
  '\nYou will still be billed for the request.',
  DELETING_COMPANY_DOCUMENT: 'deleting company document',
  DELETING_EMPLOYEE_DOCUMENT: 'deleting employee document',
  DELETING_SIGNATURE_REQUEST: 'deleting signature request',
  DETAILS: 'Details',
  DISABLE_ESIGNATURE_LIST_HEADER: 'Your Enhanced E-Signature documents will be saved, but you won’t be able to:',
  DISABLE_ESIGNATURE_PREFACE: 'The following changes will take effect immediately when you disable Enhanced E-Signature.',
  DISABLING: 'Disabling',
  DISCARD: 'Discard',
  DISCARDING: 'Discarding',
  DOCUMENTS: 'Documents',
  DOCUMENT_CATEGORY_CANNOT_EXCEED_50_CHARACTERS: 'Document category title cannot exceed 50 characters',
  DOCUMENT_COUNT: '{documentCount} document{documentPlural}',
  DOCUMENT_DELETED: 'Document deleted!',
  DOCUMENT_EDITOR: 'Document editor',
  DOCUMENT_INFORMATION: 'Document information',
  DOCUMENT_OPTIONS: 'Document options',
  DOCUMENT_PREVIEW: 'Preview',
  DOCUMENT_SIGNED: 'The document was successfully signed!',
  DOCUMENT_TO_BE_SIGNED: 'Document to be signed',
  DOCUMENT_TYPE_CANNOT_BE_DELETED_MESSAGE: 'This type of document cannot be deleted.',
  DOCUMENT_UPDATED: 'Document updated!',
  DOCUMENT_UPLOAD: 'Document upload',
  DOCUMENT_WILL_NOT_BE_SAVED: 'The document will not be saved.',
  DROP_A_DOCUMENT_HERE: 'Drop a document here',
  EDIT: 'Edit',
  EDIT_TEMPLATE: 'Edit Template',
  EMPLOYEE: 'Employee',
  EMPLOYEE_DOCUMENTS: 'Employee documents',
  EMPLOYEE_HANDBOOK: 'Employee Handbook',
  EMPLOYEE_MISSING_EMAIL_TOOLTIP: 'Employee is missing email address',
  EMPLOYEE_MISSING_EMAIL_WARNING_MESSAGE: 'The request could not be sent to {failures} employee{failurePlural} with no email address listed.',
  EMPLOYEE_MISSING_EMAIL_GENERIC_WARNING_MESSAGE: 'The request could not be sent to one or more employee(s) with no email address listed.',
  EMPLOYEE_NAME: 'Employee name',
  ENABLE: 'Enable',
  ENABLE_ENHANCED_ESIGNATURE: 'Enable Enhanced E-Signature',
  ENABLE_ESIGNATURE_LIST_HEADER: 'Signature requests are billed for:',
  ENABLED: 'Enabled',
  ENABLING: 'Enabling',
  ENHANCED_ESIGNATURE: 'Enhanced E-Signature',
  ENHANCED_ESIGNATURE_DESC: `Configure signature templates for existing documents and agreements.
   Supports custom signature locations and conditional fields and validation.`,
  ENHANCED_ESIGNATURE_NOTE: `Provider needs to acquire a contractual agreement prior to providing the enhanced e-signature feature, 
  which could be obtained from Asure Billing.`,
  ENHANCED_ESIGNATURE_MESSAGE: 'Use a form builder to create a custom signature template for the document.',
  ENTER_EMPLOYEE_NAME_OR_ID_NUMBER: 'Enter employee name or ID number',
  ESIGN_DISCLOSURES_BLURB: `By typing my name below, I understand that I am electronically signing this document. I have read, understand
   and agree to all statements, agreements, and acknowledgements in this document and in the`,
  ESIGN_DISCLOSURES_LINK: 'E-Signature Disclosures and Consent',
  ESIGNATURE_BILLING_CONFIRMATION: 'I understand that by enabling Enhanced E-Signature I will be billed as outlined above.',
  ESIGNATURE_REQUIRED: 'E-signature required',
  ESIGNED_ON: 'E-Signed on',
  EVERY_DOC_IN_ONBOARDING: 'Every Enhanced E-Signature document included in an employee’s onboarding.',
  EVERY_SENT_DOCUMENT: 'Every employee that you send an Enhanced E-Signature document to for signature.',
  ESIGNATURE_DISABLED_SUCCESS: 'Enhanced E-signature successfully disabled.',
  ESIGNATURE_ENABLED_SUCCESS: 'Enhanced E-signature successfully enabled.',
  EXISTS_IN_TASK_LIST_WARNING: `This document is associated with one or more onboarding task lists.
    Deleting it will remove it from all task lists it is currently associated with.`,
  EXIT_CONFIRMATION_TITLE: 'Quit adding the document?',
  FILE_UPLOADED: 'File uploaded!',
  FILE_UPLOAD_CANNOT_EXCEED: 'File uploads cannot exceed ',
  FILE_SIZE_UNIT_MB: 'MB',
  GET_TENANT_ESIGNATURE_DATA: 'Get tenant E-Signature data',
  GETTING_COMPANY: 'loading the company',
  GETTING_COMPANIES: 'loading companies',
  GETTING_COMPANY_DOCUMENT_CATEGORIES: 'loading document categories',
  GETTING_CREATE_TEMPLATE_URL: 'loading the template creation application',
  GETTING_DOCUMENT_DOWNLOAD_URL: 'loading download URL',
  GETTING_DOCUMENT_PREVIEW_URL: 'loading preview URL',
  GETTING_EMPLOYEE_DOCUMENT_CATEGORIES: 'loading document categories',
  GETTING_ESIGN_DOCS: 'loading documents',
  GETTING_EMPLOYEES: 'loading employees',
  GETTING_EMPLOYEE_DOCUMENTS: 'loading employee documents',
  GETTING_ONBOARDING_DOCS: 'loading onboarding documents',
  GETTING_ONBOARDING_DOCUMENT_DOWNLOAD_URL: 'loading document download url',
  GETTING_ONBOARDING_DOCUMENT_PREVIEW_URL: 'loading document preview url',
  GETTING_SIGN_URL: 'signing the document',
  GETTING_TASKLIST_DOCS: 'getting task list documents',
  GETTING_TENANT_ESIGNATURE_DATA: 'getting tenant E-Signature data',
  GETTING_UPLOAD_URL: 'uploading the document',
  GETTING_USER_ROLES: 'determining your permissions',
  GO_BACK: 'Go back',
  GO_TO_DOCUMENTS: 'go to documents',
  HELP_ENHANCED_ESIGNATURE_1: `Choose this option for documents such as contracts, where you need the employee to sign or initial specific places 
  in the document; or you need to insert custom fields such as dates, dropdowns, checkboxes and more.`,
  HELP_ENHANCED_ESIGNATURE_2: 'Using the document that you upload, you can build out a template using a drag and drop form builder.',
  HELP_LEGACY_1: 'You are limited to using Enhanced E-Signature documents for self-service onboarding of new hires.',
  HELP_LEGACY_2: `If you want to send the document to employees to fill and sign, you’ll need to add Enhanced E-Signature to your plan for a 
  small monthly and per signature request fee.`,
  HELP_ME_CHOOSE: 'Help me choose',
  HELP_NO_SIGNATURE: 'Use this option for documents that don’t need to be signed.',
  HELP_SIMPLE_ESIGNATURE_1: 'This option works well for documents such as handbooks, where employees only need to sign an acknowledgement.',
  HELP_SIMPLE_ESIGNATURE_2: `No special setup or configuration is needed for the document. Employees are prompted to sign a standard 
  acknowledgement, and a signature page is automatically appended.`,
  HELP_SIMPLE_ESIGNATURE_3: 'The signature page captures the important details including the employee’s name, and the date and time it was signed.',
  INCLUDE_IN_ONBOARDING: 'Include them in onboarding.',
  LEARN_MORE: 'Learn more.',
  LEARN_MORE_ENHANCED_ESIGNATURE: 'Learn more about Enhanced E-Signature',
  LEGACY_DISABLE_MESSAGE: `Employees will be able to complete existing signature requests,
  and you can continue to use Enhanced E-Signature documents in onboarding at no cost.`,
  LEGACY_LIMITATIONS: "You'll be limited to using the document for self service onboarding, unless you ",
  LOADING_MORE_DOCUMENTS: 'Loading more documents',
  LOADING: 'Loading',
  NEED_TO_BE_SIGNED: 'that need{documentSingular} to be signed',
  NEXT: 'Next',
  NO: 'No',
  NO_DOCUMENTS_MATCH: 'No documents match your search',
  NO_GO_BACK: 'No, go back',
  NO_SIGNATURE: 'No signature',
  NO_SIGNATURE_REQUIRED: 'No signature required',
  NON_LEGACY_DISABLE_MESSAGE: 'If you have Enhanced E-Signature documents included in any onboarding task lists, they will be removed automatically.',
  NONE: 'None',
  NOTE: 'Note:',
  ONBOARDING_CATEGORY_WARNING: `If you would like to use this document in an onboarding task list, you must
   set the Category to onboarding and require an E\u2011signature.`,
  ONBOARDING_DOCUMENT: 'Onboarding document',
  ONLY_SOME_EMPLOYEES: 'Only some employees',
  OPENING_EDITOR: 'Opening Editor',
  OR: 'or',
  PER_MONTH_BASIS: 'per month base',
  PER_SIGNATURE_REQUEST: 'per signature request',
  COST_SIGNATURE_MESSAGE: `There is a per signature cost and a monthly cost charged for this service. 
  Provider must refer to their contract for the costs.`,
  PLAN: 'Plan',
  PLEASE_CHECK_BOX: 'Please check the box to acknowledge you understand',
  PLEASE_SELECT_A_CATEGORY: 'Please select a category.',
  PLEASE_SELECT_A_COMPANY: 'Please select a company.',
  PLEASE_SELECT_AN_EMPLOYEE: 'Please select an employee',
  PLEASE_SPECIFY_A_DISPLAY_NAME: 'Please specify a display name',
  PLEASE_SPECIFY_A_TITLE: 'Please specify a title',
  PLEASE_TRY_AGAIN: 'Please try again in a few moments.',
  PLEASE_TRY_AGAIN_LATER: 'Please try again later.',
  PLEASE_TYPE_YOUR_NAME: 'Please type in your name to e-sign this document.',
  PREPARE_DOCUMENT: 'Prepare document',
  PREPARING_DOCUMENT: 'Preparing document',
  PREVIEW_UNAVAILABLE: 'Preview unavailable',
  PREVIEW_UNAVAILABLE_DOWNLOAD_AND_SIGN: 'Please download the document to review it, then add your signature below.',
  PREVIEW_UNAVAILABLE_PENDING: 'A preview will be available once the document has been signed.',
  PREVIEW_UNAVAILABLE_PROCESSING: 'A signature is being processed on this document.',
  PUBLISHED_TO_EMPLOYEE: 'Published to Employee',
  QUIT_EDITING: 'Quit editing?',
  RECENT: 'Recent',
  REFRESHING_EMPLOYEE_DOCUMENTS: 'refreshing employee documents',
  REMINDER_SENT: 'Reminder email sent to {employeeName}.',
  REMINDER_SENT_DEFAULT: 'Reminder email sent.',
  REVIEW_AND_ESIGN_DOCUMENTS: 'Documents for you to review and sign',
  REVIEW_AND_SIGN: 'Review & Sign',
  REVIEW_AND_SIGN_WARNING: 'Please review and sign all documents.',
  SAVE: 'Save',
  SAVE_CHANGES: 'Save changes',
  SAVING_CHANGES: 'Saving changes',
  SEARCHING_EMPLOYEES: 'searching for employees',
  SELECT_A_COMPANY: 'Select a company',
  SELECT_A_COMPANY_VERBIAGE: 'Please select a company using the company search above.',
  SELECT_AN_EMPLOYEE: 'Select an employee',
  SELECT_AN_EMPLOYEE_VERBIAGE: 'Please select a employee using the employee search above.',
  SELECT_COMPANY_DOCUMENTS: 'Select/Change Company Documents',
  SELECT_EMPLOYEES: 'Select employees',
  SEND_A_REMINDER: 'Send a reminder',
  SEND_FOR_SIGNATURES: 'Send for signatures',
  SEND_REMINDER: 'Send reminder',
  SEND_REQUEST: 'Send request',
  SEND_TO_EMPLOYEES: 'Send them to employees to sign.',
  SENDING_REMINDER_EMAIL: 'Sending reminder email.',
  SIGNATURE_NEEDED: 'Your signature is needed',
  SIGNATURE_NOT_REQUIRED: 'A signature is not required',
  SIGNATURE_OPTION: 'Signature option',
  SIGNATURE_OPTIONS: 'Signature options',
  SIGNATURE_STATUS: 'Signature Status',
  SIGNING: 'Signing',
  SIGN_THIS_DOCUMENT: 'E-Sign',
  SIGNATURE_REQUEST_SENT: 'Signature request sent!',
  SIGNATURE_REQUEST_SENT_TO_EMPLOYEES: 'Signature request for "{title}" has been sent to {employeeCount} employee{plural}.',
  SIGNATURE_TEMPLATE_TOOLTIP: 'Signature templates can only be used for onboarding documents',
  SIMPLE_ESIGNATURE: 'Simple E-Signature',
  SIMPLE_ESIGNATURE_EDIT: 'A signature page is appended to the document when signed.',
  SIMPLE_ESIGNATURE_MESSAGE: 'A signature page is appended to the document once an acknowledgement is signed. No setup is needed.',
  SOME_FEATURES_MAY_NOT_BE_AVAILABLE: 'Some features may not be available',
  SOMETHING_WENT_WRONG: 'Sorry, something went wrong.',
  SUCCESSFULLY_UPLOADED: 'Successfully uploaded {fileName}',
  TEMPLATE_CREATED: 'Template created!',
  TEMPLATE_UPDATED: 'Template updated!',
  THERE_WAS_A_PROBLEM: 'There was a problem',
  THIS_ACTION_CANNOT_BE_UNDONE: 'This action cannot be undone',
  TITLE: 'Title',
  TO_YOUR_PLAN: ' to your plan.',
  TO_YOUR_PLAN_EXTENDED: ' to your plan to use this option.',
  TYPE_YOUR_FULL_NAME: 'Type your full name',
  UPDATING_COMPANY_DOCUMENT: 'Updating company document',
  UPDATING_EMPLOYEE_DOCUMENT: 'Updating employee document',
  UPDATE_DOCUMENT: 'Update document',
  UPDATE_ESIGNATURE_PRODUCT_TIER: 'Update E-Signature product tier',
  UPDATING_DOCUMENT: 'Updating document',
  UPDATING_SIGNATURE_REQUEST_STATUS: 'updating the signature request status',
  UPDATE_ESIGNATURE_DOCUMENT_WARNING: 'Note: the information and options for documents that require e-signature may not be edited at this time.',
  UPDATING_ESIGNATURE_PRODUCT_TIER: 'updating E-Signature product tier',
  UPLOAD: 'Upload',
  UPLOADING: 'Uploading',
  UPLOAD_DOCUMENT: 'Upload document',
  UPLOADING_DOCUMENT: 'Uploading document',
  UPLOADED: 'Uploaded',
  UPLOADED_BY: 'Uploaded by',
  UPLOADING_COMPANY_DOCUMENT: 'uploading this company document',
  UPLOADING_EMPLOYEE_DOCUMENT: 'uploading this employee document',
  UPLOADING_SIMPLE_SIGNATURE_REQUEST: 'uploading this signature request',
  UNSUPPORTED_FILE_TYPE: 'This file type is not supported.',
  FILE_COULD_NOT_BE_PREVIEWED: 'This file format cannot be previewed. Click here to download it.',
  VIEW_DOCUMENT: 'View document',
  VISIBILITY: 'Visibility',
  VISIBILITY_MESSAGE: 'Make the document visible to all employees',
  VISIBLE_TO_EMPLOYEE: 'Visible to employee',
  WARNING: 'Warning',
  WHO_NEEDS_TO_SIGN: 'Who needs to sign?',
  NO_DOCUMENTS_TO_DISPLAY: 'There are no documents to display.',
  YES: 'Yes',
  YES_QUIT: 'Yes, quit',
  YOU_CAN: 'You can',
  YOU_HAVE: 'You have',
  YOU_CAN_SELECT_SIGNATURE_OPTIONS: 'You can select signature options for the document in the next step.',
  YOUR_CHANGES_WONT_BE_SAVED: 'Your changes won\'t be saved.',
  YOUR_CHANGES_WONT_BE_SAVED_AMBIGUOUS: 'If you have made any changes, they won\'t be saved.',
};



// WEBPACK FOOTER //
// ./src/i18n/en-us.js